import React from 'react';
import './XSLoadingSpinner.css';
import clsx from 'clsx';

export function XSLoadingSpinner() {
    return (
        <div className={clsx(`XSLoadingSpinner`)}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}
